<template>
  <div>

    <div class="card_bind_content">

      <div class="card_bind_title">
        绑定卡币
        <div class="card_bind_title_line"></div>
      </div>

      <div class="card_bind_input_view">
        <div class="card_bind_input_left">
          账户
        </div>
        <div class="card_bind_input_right">
          <div class="card_bind_input_div">
            <input placeholder="请输入礼品卡账户" v-model="cardNumber"/>
          </div>

        </div>
      </div>

      <div class="card_bind_input_view">
        <div class="card_bind_input_left">
          卡密码
        </div>
        <div class="card_bind_input_right">
          <div class="card_bind_input_div">
            <input placeholder="请输入礼品卡密码" v-model="password"/>
          </div>
          <div class="card_bind_input_desc">
            <div class="card_bind_input_desc_left">
              <img src="../../../images/BindCard_Icon_Tips@3x.png"/>
              卡片背面刮开涂层查看卡密码
            </div>

          </div>
        </div>
      </div>

      <div class="card_bind_button" @click="bindCard()">
        <button>绑定</button>
      </div>

    </div>

    <van-loading type="spinner" vertical="true" v-show="isLoading"/>

  </div>

</template>

<script>

  import Vue from 'vue'
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getProductReviews,partyGetSendCaptcha,getWithdrawApply,activationKCoinCard} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,Dialog,Loading} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import {setStore,getStore} from "../../../utils/mUtil";


  export default {
    name: "cardBind",
    data(){
      return{
        token:getStore('externalLoginKey'),
        cardNumber:'',
        password:'',
        isLoading:false
      }
    },

    mounted(){
      this.showLoading = false;
    },
    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      loading,
      [Dialog]:Dialog,
      [Loading.name]:Loading
    },

    methods:{



      activationKCoinCard:function(){
        this.isLoading = true
        var param = {
          externalLoginKey:this.token,
          cardNumber:this.cardNumber,
          password:this.password
        }
        console.log(param)
        activationKCoinCard(param)
          .then(res => {
            console.log("activationKCoinCard")
            console.log(res)
            this.isLoading = false
            if(res._ERROR_MESSAGE_){
              Toast(res._ERROR_MESSAGE_)
            }else{
              //绑定成功
              Dialog.confirm({
                title: '绑定成功',
                message: '',
                confirmButtonText:'继续绑卡',
                confirmButtonColor:'#EB7AA0 ',
                cancelButtonText:'前往首页',
                cancelButtonColor:'#333333',
              })
                .then(() => {
                  // on confirm
                  this.password = ''
                  this.cardNumber = ''
                })
                .catch(() => {
                  // on cancel
                  console.log('返回首页')
                  console.log(wx.miniProgram)
                  wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
                });
            }
          })
          .catch(err => {
            this.isLoading = false
            console.log(err);
          });
      },


      bindCard:function(){
        console.log(this.cardNumber)
        console.log(this.password)
        if(this.cardNumber!=''&&this.password!=''){
          this.activationKCoinCard()
        }else{
          Toast('请填写账户或密码')
        }

      }


    }

  }

</script>

<style>
  .card_bind_content{
    width:20.3125rem;
    margin: 1.75rem auto;
  }
  .card_bind_title{
    width:100%;
    text-align: left;
    font-size: 0.875rem;
    color:#000;
  }
  .card_bind_title_line{
    width:3.5rem;
    border-bottom: 4px solid lightpink;
    position: relative;
    top: -0.4rem;
    opacity: 0.5;
  }
  .card_bind_input_view{
    width:100%;
    margin: 1.25rem 0;
  }
  .card_bind_input_left{
    display: inline-block;
    vertical-align: top;
    width:3rem;
    color:#4a4a4a;
    font-size: 0.75rem;
    height: 1.5rem;
    line-height: 1.5rem;
  }

  .card_bind_input_right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 3.4rem)
  }
  .card_bind_input_div{
    width:16.8rem
  }
  .card_bind_input_div input{
    height: 1.5rem;
    width:16.3rem;
    border: 1px solid #999;
    border-radius: 4px;
    font-size: 0.75rem;
    padding-left: 0.5rem;
    background-color: #FBFBFB;
  }
  .card_bind_input_div img{
    width:1rem;
    height: 1rem;
    position: absolute;
    top: 4.8rem;
    right: 1.8rem;
  }
  .card_bind_input_desc{
    font-size: 0.625rem;
    margin-top: 0.5rem;
    width:100%;
  }
  .card_bind_input_desc_left{
    display: inline-block;
    vertical-align: top;
    color:#878787;
  }
  .card_bind_input_desc_left img{
    width:0.625rem;
    height: 0.625rem;
  }
  .card_bind_input_desc_right{
    display: inline-block;
    vertical-align: top;
    color:#E50113;
    float: right;
  }

  .card_bind_button{
    width:100%;
  }
  .card_bind_button button{
    width:100%;
    border-radius:1.17rem;
    background-color: #EB7AA0;
    text-align: center;
    color:white;
    height: 2.34rem;
    line-height: 2.34rem;
    font-size: 0.75rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/cardCurrency/cardBind.vue